export default "__VITE_ASSET__DlHJvX4C__"